var ability = {
    methods: {
    ability(ably) {
        if(!ably) return true
        const userdata = JSON.parse(localStorage.getItem('userdata'))
         
        if(ably.indexOf('|') > -1){ // bu yetkilerde göster
          let currentRole = ably.split('|')
          return currentRole.includes(userdata.role_name)
        }
        return userdata.role_name == ably
      },
    },
  }
  
  export default ability